import React, { FC, Fragment } from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { TransportLine, TransportOrder } from 'models/transport';
import { useTranslation } from 'react-i18next';
import LockIcon from '@mui/icons-material/Lock';
import { transportDateHelper } from 'utils/transport-date-helper';
import TransportScheduleItem from './transport-schedule-item.component';
import { NShiftShipmentWaybill } from 'models/nshift-shipment-waybill';

type TransportScheduleProps = {
    transportLines: TransportLine[];
    onTransportClick: (transportOrder?: TransportOrder, waybills?: NShiftShipmentWaybill[]) => void;
    selectedDate: Date | null;
};
const TransportSchedule: FC<TransportScheduleProps> = ({
    transportLines,
    onTransportClick,
    selectedDate,
}: TransportScheduleProps) => {
    const { t: translate } = useTranslation(['common', 'transport']);

    return (
        <Fragment>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>{translate('common:CLINIC')}</TableCell>
                            <TableCell sx={{ width: '20%' }}>
                                <Box display="flex" alignItems="center">
                                    {selectedDate && transportDateHelper.isPickupDisabled(selectedDate) ? (
                                        <LockIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                                    ) : undefined}
                                    {translate('transport:PICKUP')}
                                </Box>
                            </TableCell>
                            <TableCell sx={{ width: '25%' }}>
                                <Box display="flex" alignItems="center">
                                    {selectedDate && transportDateHelper.isDeliveryDisabled(selectedDate) ? (
                                        <LockIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                                    ) : undefined}
                                    {translate('transport:DELIVERY')}
                                </Box>
                            </TableCell>
                            <TableCell sx={{ width: '230px' }}>
                                <Box display="flex" alignItems="center">
                                    {translate('transport:FEE')}
                                </Box>
                            </TableCell>
                            <TableCell sx={{ width: '150px' }}>{translate('transport:CARRIER')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {transportLines.map((transportLine, index) => (
                            <TransportScheduleItem
                                transportLine={transportLine}
                                onTransportClick={onTransportClick}
                                key={index}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Fragment>
    );
};

export default TransportSchedule;
